import type { SlateEditor, TElement } from '@udecode/plate';

import {
    BaseTableCellHeaderPlugin,
    BaseTableCellPlugin,
} from '../BaseTablePlugin';
import type { CreateCellOptions } from '../types';

export const getEmptyCellNode = (
    editor: SlateEditor,
    { children, header, row }: CreateCellOptions = {}
) => {
    header =
    header ??
    (row
        ? (row as TElement).children.every(
            (c) => c.type === editor.getType(BaseTableCellHeaderPlugin)
        )
        : false);

    return {
        children: children ?? [editor.api.create.block()],
        type: header
            ? editor.getType(BaseTableCellHeaderPlugin)
            : editor.getType(BaseTableCellPlugin),
    };
};
